import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creation: {
    pages: [],
    originalData: null,
  },
  update: {
    pages: [],
    hasChanges: false,
  },
  display: {
    pages: [],
    loading: false,
    error: null,
  },
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    // Creation actions - Pages
    updateCreationPages: (state, action) => {
      state.creation.pages = action.payload;
    },
    addCreationPage: (state, action) => {
      state.creation.pages.push(action.payload);
    },
    removeCreationPage: (state, action) => {
      state.creation.pages = state.creation.pages.filter(
        (p) => p.id !== action.payload,
      );
    },

    resetCreation: (state) => {
      state.creation = initialState.creation;
    },
    loadCreationData: (state, action) => {
      state.creation.pages = action.payload.pages || [];
    },
    setCreationOriginalData: (state, action) => {
      state.creation.originalData = action.payload;
    },

    // Update actions - Pages
    updateUpdatePages: (state, action) => {
      state.update.pages = action.payload;
      state.update.hasChanges = true;
    },
    addUpdatePage: (state, action) => {
      state.update.pages.push(action.payload);
      state.update.hasChanges = true;
    },
    removeUpdatePage: (state, action) => {
      state.update.pages = state.update.pages.filter(
        (p) => p.id !== action.payload,
      );
      state.update.hasChanges = true;
    },

    loadUpdateData: (state, action) => {
      state.update.pages = action.payload.pages || [];
      state.update.hasChanges = false;
    },
    clearUpdateChanges: (state) => {
      state.update.hasChanges = false;
    },
    resetUpdate: (state) => {
      state.update = initialState.update;
    },

    // Display actions
    setDisplayData: (state, action) => {
      state.display.pages = action.payload.pages || [];
      state.display.loading = false;
      state.display.error = null;
    },
    setDisplayLoading: (state, action) => {
      state.display.loading = action.payload;
    },
    setDisplayError: (state, action) => {
      state.display.error = action.payload;
      state.display.loading = false;
    },
    resetDisplay: (state) => {
      state.display = initialState.display;
    },
  },
});

export const {
  updateCreationPages,
  addCreationPage,
  removeCreationPage,
  loadCreationData,
  setCreationOriginalData,
  updateUpdatePages,
  addUpdatePage,
  removeUpdatePage,
  loadUpdateData,
  clearUpdateChanges,
  resetCreation,
  resetUpdate,
  setDisplayData,
  setDisplayLoading,
  setDisplayError,
  resetDisplay,
} = pageSlice.actions;

export default pageSlice.reducer;
